// Vendor
import * as React from 'react';

const Sources: React.FC = () => {
  const classesParagraph = 'tup-body leading-7';

  return (
    <div className="tup-slide" id="sources">
      <h1 className="mb-8">Primary Sources</h1>
      <p className={classesParagraph}>
        1. <b>GlobalData Market Sizing:</b> GlobalData’s assessment of the
        secondhand market is determined through ongoing retailer tracking,
        official public data, data sharing, store observation, consumers
        surveys, and secondary sources. These inputs are used by analysts to
        model and calculate market sizes, channel sizes, and market shares.
        Market data analysis included in this report was done in April, 2020 and
        includes the impact of Covid.
      </p>
      <p className={classesParagraph}>
        2. <b>GlobalData Consumer Survey:</b> The consumer data in this report
        is derived from a consumer survey of 3,500 women. The survey asked them
        a number of questions about their attitudes towards apparel, secondhand
        products, and resale products. The sample was designed to be
        representative of age and income and was also geographically
        representative. Surveying was undertaken by GlobalData between December
        12, 2019 and January 6, 2020.
      </p>
      <p className={classesParagraph}>
        3. <b>GlobalData Covid Survey:</b> GlobalData performed a second
        consumer survey of 2,000 women in April, 2020 which specifically focused
        on changes in attitudes towards apparel, secondhand products, and resale
        products in light of impact of the global pandemic.
      </p>
      <p className={classesParagraph}>
        4.{' '}
        <b>
          <a
            className="underline"
            href="https://secondmeasure.com/datapoints/fashion-resale-sees-growth/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Second Measure Transaction Data:
          </a>
        </b>{' '}
        Second Measure tracks, analyzes, and benchmarks U.S. transaction trends
        through direct to consumer channels
      </p>
      <h1 className="mb-8 mt-16">Secondary Sources</h1>
      <p className={classesParagraph}>
        5. <b>GlobalData Fashion Retailer Survey:</b> 50 U.S. fashion (apparel,
        accessories, footwear) retailers were surveyed from December 12, 2019 to
        January 6, 2020 about their Circular Fashion goals.
      </p>
      <p className={classesParagraph}>
        6. <b>Green Story Inc. Environmental Study:</b> Independent research
        firm, Green Story Inc., was contracted to calculate the environmental
        savings from reuse of secondhand garments sold by thredUP. The study
        compared the environmental burden of purchasing a brand-new garment with
        that of reusing an average garment sold by thredUP across all stages of
        the garment’s lifecycle. The savings were calculated across three areas:
        greenhouse gas emissions, energy use, and water consumption. The study
        followed international ISO 14040 LCA standard.
      </p>
      <p className={classesParagraph}>
        7. <b>Resale Value Rankings:</b> thredUP evaluated 35,000+ unique brands
        on its platform and created an aggregate score to determine a
        brand&apos;s ranking based on demand, virality and value to the seller.
      </p>
      <p className={classesParagraph}>
        8. Internal thredUP Customer Behavior / Data.
      </p>
      <p className={classesParagraph}>
        10. GlobalData Seller Survey of 2,000 U.S. Women on clothing resale
        habits
      </p>

      <h1 className="mb-8 mt-16">Other Reports & Articles Referenced</h1>
      <p className={classesParagraph}>
        <b>Cowen Equity Research:</b> Cowen’s Best ESG Investment Ideas for
        2020; March 3, 2020
      </p>
      <p className={classesParagraph}>
        <b>Department of Health and Environmental Control:</b>{' '}
        <a
          className="underline"
          href="https://www.scdhec.gov/environment/land-and-waste-landfills/how-landfills-work"
          rel="noopener noreferrer"
          target="_blank"
        >
          How Landfills Work
        </a>
      </p>
      <p className={classesParagraph}>
        <b>Deloitte:</b>{' '}
        <a
          className="underline"
          href="https://www2.deloitte.com/us/en/insights/industry/financial-services/esg-investing-performance.html"
          rel="noopener noreferrer"
          target="_blank"
        >
          Advancing environmental, social, and governance investing:
        </a>{' '}
        A holistic approach for investment management firms
      </p>
      <p className={classesParagraph}>
        <b>
          The Forum for Sustainable and Responsible Investment (US SIF
          Foundation):
        </b>{' '}
        <a
          className="underline"
          href="https://www.ussif.org/files/Trends/Trends%202018%20executive%20summary%20FINAL.pdf"
          rel="noopener noreferrer"
          target="_blank"
        >
          Report on US Sustainable, Responsible and Impact Investing Trends 2018
        </a>
      </p>
    </div>
  );
};

export { Sources };
